/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Bumble downloaden",
      "Alle akzeptieren",
      "Optionen verwalten",
      "Cookie-Richtlinie",
      "Zurück",
      "Telefonnummer fehlerhaft",
      "© {{current_year}} Bumble | Alle Rechte vorbehalten",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Über uns",
      "Ambassadors",
      "Blog",
      "Wir verwenden Cookies. Wenn du deine Einstellungen nicht änderst, erklärst du dich damit einverstanden.",
      "Jetzt App downloaden",
      "Zum Android-Download",
      "Zum iOS-Download",
      "Wir konnten die gesuchte Seite leider nicht finden.",
      "Einloggen",
      "Mitmachen",
      "Sei dabei!",
      "Sorry, da ist was schiefgegangen!"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "Tage",
                  "Tage",
                  "Tagen",
                  "Tage"
            ],
            "singular": [
                  "Tag",
                  "Tags",
                  "Tag",
                  "Tag"
            ]
      },
      "hour": {
            "plural": [
                  "Stunden",
                  "Stunden",
                  "Stunden",
                  "Stunden"
            ],
            "singular": [
                  "Stunde",
                  "Stunde",
                  "Stunde",
                  "Stunde"
            ]
      },
      "minute": {
            "plural": [
                  "Minuten",
                  "Minuten",
                  "Minuten",
                  "Minuten"
            ],
            "singular": [
                  "Minute",
                  "Minute",
                  "Minute",
                  "Minute"
            ]
      },
      "month": {
            "plural": [
                  "Monate",
                  "Monate",
                  "Monaten",
                  "Monate"
            ],
            "singular": [
                  "Monat",
                  "Monats",
                  "Monat",
                  "Monat"
            ]
      },
      "second": {
            "plural": [
                  "Sekunden",
                  "Sekunden",
                  "Sekunden",
                  "Sekunden"
            ],
            "singular": [
                  "Sekunde",
                  "Sekunde",
                  "Sekunde",
                  "Sekunde"
            ]
      },
      "year": {
            "plural": [
                  "Jahre",
                  "Jahre",
                  "Jahren",
                  "Jahre"
            ],
            "singular": [
                  "Jahr",
                  "Jahres",
                  "Jahr",
                  "Jahr"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
